import { useState, createContext, useContext } from "react";
import { translations } from "./translations";

const LanguageContext = createContext();

export const useLanguage = () => useContext(LanguageContext);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem('vf-lang') || 'fr');

  const toggleLanguage = () => {
    const newLang = lang === 'fr' ? 'br' : 'fr';
    setLang(newLang);
    localStorage.setItem('vf-lang', newLang);
  };

  const t = (path) => {
    const keys = path.split('.');
    let result = translations[lang];
    for (const key of keys) {
      result = result?.[key];
    }
    return result || path;
  };

  return (
    <LanguageContext.Provider value={{ lang, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};
